import React from 'react'
import StatisticData from 'sections/statistics/pages/ShopStatistic/components/StatisticData'
import StatisticShopProvider from 'sections/statistics/pages/ShopStatistic/contexts/StatisticShopContext'
import Filter from 'sections/statistics/pages/ShopStatistic/components/Filter'

export default function ShopStatistic() {
	return (
		<StatisticShopProvider>
			<Filter />
			<StatisticData />
		</StatisticShopProvider>
	)
}
